import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { getReport } from 'App/services/ReportEngineService';
import { queryClient } from 'Shared/queryClient';

const propTypes = {
    dash: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {};

function loadDashboard(id) {
    return getReport('dashboard', id).then((res) => {
        queryClient.setQueryData(['insights', 'embedUrl'], res);
    });
}

function DashboardButton({ dash }) {
    return (
        <Button variant="link" onClick={() => loadDashboard(dash.id)}>
            {dash.title}
        </Button>
    );
}

DashboardButton.propTypes = propTypes;
DashboardButton.defaultProps = defaultProps;

export default DashboardButton;
